import { createFileRoute } from '@tanstack/react-router';
import { MarketingShell } from '../components/shell/MarketingShell.tsx';

export const Route = createFileRoute('/_marketing')({
  component: MarketingShell,
});
